"use client";

import { c as _c } from "react/compiler-runtime";
import { InstagramIcon, Mail01Icon, NewTwitterIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import type { Route } from "next";
import Link from "next/link";
import { usePathname } from "next/navigation";
import ModeToggle from "@/components/blocks/ModeToggle";
import Logo from "@/components/brand/Logo";
const FOOTER_LINKS = [{
  title: "Platform",
  links: [{
    name: "Dashboard",
    href: "/dashboard"
  }, {
    name: "Tournaments",
    href: "/tournaments"
  }, {
    name: "Venues",
    href: "/venues"
  }]
}, {
  title: "Connect",
  links: [{
    name: "Contact Us",
    href: "/contact"
  }, {
    name: "Login",
    href: "/auth/login"
  }]
}, {
  title: "Legal",
  links: [{
    name: "Terms",
    href: "/terms"
  }, {
    name: "Privacy",
    href: "/privacy"
  }, {
    name: "Cookies",
    href: "/cookie-policy"
  }]
}] satisfies Array<{
  title: string;
  links: Array<{
    name: string;
    href: Route;
  }>;
}>;
export default function Footer() {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Date().getFullYear();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const currentYear = t0;
  const pathname = usePathname();
  const isHomePage = pathname === "/";
  const t1 = `mx-auto rounded-2xl transition-all duration-500 ease-in-out ${isHomePage ? "w-full max-w-[100vw] px-6 lg:px-12" : "w-full max-w-7xl px-8"}`;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex max-w-sm flex-col gap-6"><Link href="/" className="w-fit text-foreground transition-transform duration-300"><Logo variant="combo" size="lg" className="text-3xl" /></Link></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col items-start justify-between gap-12 pb-12 lg:flex-row lg:gap-8">{t2}<div className="grid w-full grid-cols-2 gap-8 md:grid-cols-3 md:gap-16 lg:w-auto">{FOOTER_LINKS.map(_temp2)}</div></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="order-2 sm:order-1"><p className="flex items-center gap-1.5">© {currentYear} Clutch. All rights reserved.</p></div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Link href="mailto:contact@clutch.example.com" className="rounded-full bg-secondary/50 p-2.5 text-muted-foreground transition-all hover:-translate-y-1 hover:bg-secondary hover:text-foreground" aria-label="Email"><HugeiconsIcon icon={Mail01Icon} size={20} strokeWidth={1.5} /></Link>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Link href="https://x.com" target="_blank" rel="noopener noreferrer" className="rounded-full bg-secondary/50 p-2.5 text-muted-foreground transition-all hover:-translate-y-1 hover:bg-secondary hover:text-foreground" aria-label="Twitter"><HugeiconsIcon icon={NewTwitterIcon} size={20} strokeWidth={1.5} /></Link>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex flex-col items-center justify-between gap-6 border-border/50 border-t pt-5 text-muted-foreground text-sm sm:flex-row sm:gap-4">{t4}<div className="order-1 flex items-center gap-4 sm:order-2"><div className="flex items-center gap-3">{t5}{t6}<Link href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="rounded-full bg-secondary/50 p-2.5 text-muted-foreground transition-all hover:-translate-y-1 hover:bg-secondary hover:text-foreground" aria-label="Instagram"><HugeiconsIcon icon={InstagramIcon} size={20} strokeWidth={1.5} /></Link></div><div className="h-6 w-px bg-border/80" /><ModeToggle /></div></div>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t1) {
    t8 = <footer className="mt-auto border-transparent py-8 pb-20 font-sans backdrop-blur-md md:pt-16 md:pb-12 dark:border-transparent dark:bg-accent/40"><div className={t1}>{t3}{t7}</div></footer>;
    $[7] = t1;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}
function _temp2(group) {
  return <div key={group.title} className="flex flex-col gap-4"><h3 className="font-semibold text-foreground text-sm uppercase tracking-wider">{group.title}</h3><div className="flex flex-col gap-3">{group.links.map(_temp)}</div></div>;
}
function _temp(link) {
  return <Link key={link.name} href={link.href} className="w-fit text-muted-foreground text-sm transition-all hover:translate-x-1 hover:text-foreground">{link.name}</Link>;
}